<template>
  <sModal
    v-model="open"
    auto-full-screen
    body-style="padding: 5px;"
    fullscreen
    @close="open = false">
    <Breadcrumbs
      slot="header"
      class="ml-10"
      :items="breadcrumbs"/>
    <DocumentView
      v-if="open"
      ref="document_view"
      :file="file"
      :new-endpoints="newEndpoints"/>
    <div
      key="footer"
      slot="footer"
      style="display: grid; grid-template-columns: auto auto; justify-content: space-between;">
      <div class="back">
        <sButton
          data-qa="btn-file-exit"
          icon="long-arrow"
          icon-class="s-svg-icon-rotate-90"
          small
          type="text"
          @click="open = false">
          {{ $t('Common.Back') }}
        </sButton>
      </div>
      <div class="next">
        <sButton
          v-if="file && file.downloader"
          class="btn"
          data-qa="btn-file-download"
          icon="download"
          type="text"
          @click="saveFile">
          {{ $t('Tenders.Download') }}
        </sButton>
        <sButton
          v-if="img_type || html_type"
          class="btn"
          data-qa="btn-file-print"
          icon="printer"
          type="text"
          @click="printDocument">
          {{ $t('Tenders.Print') }}
        </sButton>
      </div>
    </div>
  </sModal>
</template>

<script>
import documentView from 'mixins/documentView'
import Breadcrumbs from 'components/common/elements/Breadcrumbs.vue'
import DocumentView from 'components/common/elements/DocumentView.vue'

export default {
  mixins: [documentView],
  name: 'dialogDocumentView',
  props: {
    dialog: Boolean,
    newEndpoints: Boolean
  },
  computed: {
    open: {
      get() {
        return this.dialog
      },
      set(val) {
        if (!val) { this.loadeed = true }
        this.$emit('update:dialog', val)
      }
    },
    breadcrumbs() {
      return [
        {
          text: this.$t('Tenders.Documents'),
          action: () =>  this.open = false
        },
        {
          text: this.$t('Tenders.DocumentView')  + ' ' + this.file?.title,
          // loading: this.loading
        },
      ]
    },
  },
  components: {
    Breadcrumbs,
    DocumentView
  }
}
</script>
